import { render, staticRenderFns } from "./SliderSimulator.vue?vue&type=template&id=11405f4a&"
import script from "./SliderSimulator.vue?vue&type=script&lang=js&"
export * from "./SliderSimulator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\simulador_new\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11405f4a')) {
      api.createRecord('11405f4a', component.options)
    } else {
      api.reload('11405f4a', component.options)
    }
    module.hot.accept("./SliderSimulator.vue?vue&type=template&id=11405f4a&", function () {
      api.rerender('11405f4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Simuladores/SliderSimulator.vue"
export default component.exports